import workspaceQuery from '../../queries/product/GoodsReceiptLineWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { workspaceActionsForPermissions } from '../../../actions/product/GoodsReceiptLineWorkspaceAction';

const GoodsReceiptLine: EntityType = {
  type: 'GoodsReceiptLine',
  title: 'Goods In Report',
  workspaceUrl: '/Products/StockControl/GoodsReceipt/Report',
  workspace: workspaceQuery,
  screenReference: 'PRODUCTS_STOCK_CONTROL_GOODS_IN',
  operations: 0,
  actions: workspaceActionsForPermissions,
};

export default GoodsReceiptLine;
